// StrayPaw — turuncu kedi yüzü logosu (kullanıcının gönderdiği görsel).
// Lucide ikon imzasıyla uyumlu (size + className + ...rest) ki stat kartında
// mevcut ikonun yerine doğrudan geçebilsin.
//
// PNG'nin zemini açık gri/beyaz olduğu için kartın açık turuncu kutusunda
// kare gibi durmasın diye `mix-blend-mode: multiply` ile zemin kaynaştırılır
// (beyaz → arka planı gösterir, turuncu kedi olduğu gibi kalır).
export default function CatFaceLogo({ size = 18, className = "", ...rest }) {
  // Markamız — diğer ikonlardan hafif büyük ama estetik dursun (png içi boşluklu).
  const px = size + 14;
  return (
    <img
      src="/cat-logo.png"
      alt=""
      width={px}
      height={px}
      className={className}
      style={{
        width: px,
        height: px,
        objectFit: "contain",
        mixBlendMode: "multiply",
        // PNG kırmızı-turuncu; Yapay Zeka butonunun turuncusuna kaydır.
        filter: "hue-rotate(14deg) saturate(0.95)",
      }}
      {...rest}
    />
  );
}
